/**
 * Created by Administrador on 03/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('currencyCtrl', currencyCtrl)
        .controller('newCurrencyCtrl', newCurrencyCtrl)
        .controller('editCurrencyCtrl', editCurrencyCtrl)
        .controller('deleteCurrencyController', deleteCurrencyController)
        .controller('exchangeRateCurrencyController', exchangeRateCurrencyController);

    currencyCtrl.$inject = ['currencies','linkService','countryService'];
    newCurrencyCtrl.$inject = ['currencyService','linkService','countries','currencies'];
    editCurrencyCtrl.$inject = ['currencyService','linkService','currency','countries','currencies'];
    deleteCurrencyController.$inject = ['currencyService', '$uibModalInstance', '$stateParams'];
    exchangeRateCurrencyController.$inject = ['exchangeRateService','linkService','currency','exchangeRates'];

    function currencyCtrl(currencies,linkService,countryService) {
        var vm = this;
        vm.linkService = linkService;

        vm.pages = [];
        vm.currencies = (currencies.data._embedded) ? currencies.data._embedded.currencies: [];
        vm.pages = currencies.data.page;

        angular.forEach(vm.currencies, function(currency, key) {
            countryService.getCountry(currency.countryId)
                .then(function (response) {
                    vm.currencies[key].countryName = response.data.name;
                });
        });
    }

    function newCurrencyCtrl(currencyService,linkService,countries,currencies) {
        var vm = this;
        vm.countries = getCountries(linkService, countries, currencies,0);

        vm.saveCurrency = function(isValid, currencyForm){
            if(isValid){
                currencyForm.countryId = currencyForm.country.id;
                currencyService.saveCurrency(currencyForm);
            }
        }
    }

    function editCurrencyCtrl(currencyService, linkService, currency, countries, currencies) {
        var vm = this;
        vm.countries = getCountries(linkService, countries, currencies,currency.data.countryId);
        vm.currency = currency.data;

        for(var i=0; i<vm.countries.length; i++){
            if(vm.countries[i].id==vm.currency.countryId){
                vm.currency.country = vm.countries[i];
            }
        }

        vm.saveCurrency = function(isValid, currencyForm){
            if(isValid){
                currencyForm.countryId = currencyForm.country.id;
                currencyService.updateCurrency(currencyForm,linkService.getLinkId(currencyForm._links.self.href));
            }
        }
    }

    function deleteCurrencyController(currencyService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.deleteCurrency = function(){
            currencyService.deleteCurrency($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function exchangeRateCurrencyController(exchangeRateService,linkService,currency,exchangeRates){
        var vm = this;
        vm.currency = currency.data;
        vm.exchangeRates = exchangeRates;

        for(var k=0; k<exchangeRates.length; k++){
            vm.exchangeRates[k].rateOld = exchangeRates[k].rate;
        }

        vm.updateExchangeRate = function(isValid, exchangeRate){
            if(isValid){
                exchangeRateService.updateExchangeRate(exchangeRate,linkService.getLinkId(exchangeRate._links.self.href));
            }
        }
    }

    function getCountries(linkService,countries, currencies, countryId){
        var newCountries = [];
        for(var i=0; i<countries.length; i++){
            var band = false;
            for(var j=0; j<currencies.length; j++){
                if(linkService.getLinkId(countries[i]._links.self.href)==
                    currencies[j].countryId && !(linkService.getLinkId(countries[i]._links.self.href)==countryId)){
                    band = true;
                }
            }
            if(!band){
                newCountries.push(
                    {
                        "name": countries[i].name,
                        "id": linkService.getLinkId(countries[i]._links.self.href)
                    }
                );
            }
        }
        return newCountries;
    }

})();
